import axios from "axios";
import React from "react";
import { useState } from "react";
import toast from "react-hot-toast";

const ContactThree = () => {

  const [formData, setFormData] = useState({
    fname: "",
    email: "",
    phone: "",
    message: "", 
  });
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");

  // Validation function
  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;

    if (!formData.fname.trim()) {
      newErrors.fname = "Name is required.";
    }
    if (!formData.email.trim() || !emailRegex.test(formData.email)) {
      newErrors.email = "Valid email is required.";
    }
    if (!formData.phone.trim() || !phoneRegex.test(formData.phone)) {
      newErrors.phone = "Valid 10-digit phone number is required.";
    }
    if (!formData.message.trim()) {
      newErrors.message = "Message cannot be empty.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      try {
        const response = await axios.post("/api/contact", formData, {
          headers: { "Content-Type": "application/json" },
        });

        if (response.status === 200) {
          setSuccessMessage("Your message was sent successfully!");
          toast.success("Your message was sent successfully!");

          setFormData({
            fname: "",
            email: "",
            phone: "",
            service: "option0",
            message: "",
          });
        } else {
          toast.error(response?.data?.error ?? "Failed to send the message.");
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        toast.error("An error occurred. Please try again later.");
      }
    }
  };


  return (
    <section className="contact_form_area contact_us section_padding">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div className="contact-right contact_details">
              <div className="hero-title-with-shape">
                <h4 className="heading_with_border">Contact with us</h4>
                <h1>We offer 24/7 emergency service to all of our customers</h1>
              </div>
              <p>
                There are many variations of passages of new lorem ipsum
                available, but the majority have suffered.
              </p>
              <div className="contact_location_box">
                <div className="contact_location_map">
                  <span className="icon-location"></span>
                  <p>
                    Survey No. 165, Ahmedpura, Ghadi, Himmatnagar-Talod Road,
                    Talod, Sabarkantha - 383215, Gujarat, India.
                  </p>
                </div>
                <div className="contact_location_map contact_location_call">
                  <span className="icon-contact_call"></span>
                  <p>
                    info@greecoplast.com <br />
                    +91 99090 46390
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="contact-right contact-right-style-2 responsive_mt">
              <form onSubmit={handleSubmit}>
                <div className="d-flex gap-3">
                  <div className="d-flex flex-column mb-3 w-100">
                    <input
                      className="half_width input_m_right w-100"
                      type="text"
                      name="fname"
                      placeholder="Your name"
                      value={formData.fname}
                      onChange={handleInputChange}
                    />
                    {errors.fname && <span className="error-message text-danger">{errors.fname}</span>}
                  </div>
                  <div className="d-flex flex-column mb-3 w-100">
                    <input
                      className="half_width w-100"
                      type="EMAIL"
                      name="email"
                      placeholder="Email address"
                      value={formData.email}
                      onChange={handleInputChange}
                    />
                    {errors.email && <span className="error-message text-danger">{errors.email}</span>}
                  </div>
                </div>
                <div className="d-flex flex-column mb-3">
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone number"
                    value={formData.phone}
                    onChange={handleInputChange}
                  />
                  {errors.phone && <span className="error-message text-danger">{errors.phone}</span>}
                </div>
                <div className="d-flex flex-column mb-3">
                  <textarea
                    name="message"
                    placeholder="Write your message"
                    value={formData.message}
                    onChange={handleInputChange}
                    rows="5"
                  ></textarea>
                  {errors.message && <span className="error-message text-danger">{errors.message}</span>}
                </div>
                <button className="btn-green" value="SUBMIT NOW">
                  SUBMIT NOW
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactThree;
